/**
 * Prefer `crypto.randomUUID` when available (often missing on HTTP or older runtimes).
 * Use for React keys, import previews, and other non-cryptographic client-side ids.
 */
export function randomClientId(): string {
  try {
    const c = typeof globalThis !== 'undefined' ? (globalThis as { crypto?: Crypto }).crypto : undefined;
    if (c && typeof c.randomUUID === 'function') {
      return c.randomUUID();
    }
  } catch {
    /* ignore */
  }
  return `k-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
